export class Metrics {

  public memUsed: number;
  public memFree: number;
  public memPercent: number;
  public memTotal: number;

  public processors: number;
  public uptime: number;
  public counter200 = [];
  public counter400 = [];
  public counter500 = [];

  public static fromDto(m): Metrics {
    const metrics = new Metrics();

    metrics.memUsed    = m.mem * 1000;
    metrics.memFree    = m['mem.free'] * 1000;
    metrics.memTotal   = metrics.memUsed + metrics.memFree;
    metrics.memPercent = metrics.memUsed / metrics.memTotal * 100;

    metrics.processors = m.processors;
    metrics.uptime     = Math.round(m.uptime / 1000);

    const counter200key = /^counter\.status\.(2[0-9]{2})\.(.*)$/ig;
    const counter400key = /^counter\.status\.(4[0-9]{2})\.(.*)$/ig;
    const counter500key = /^counter\.status\.(5[0-9]{2})\.(.*)$/ig;

    for (const key of Object.keys(m)) {
      if (key.match(counter200key)) {
        const result = counter200key.exec(key);
        metrics.counter200.push({ endpoint: result[2], code: result[1], value: m[key] });
      } else if (key.match(counter400key)) {
        const result = counter400key.exec(key);
        metrics.counter400.push({ endpoint: result[2], code: result[1], value: m[key] });
      } else if (key.match(counter500key)) {
        const result = counter500key.exec(key);
        metrics.counter500.push({ endpoint: result[2], code: result[1], value: m[key] });
      }
    }

    const sortCounters: (c1: any, c2: any) => number = (c1, c2) => {
      if (c1.value < c2.value) {
        return 1;
      } else if (c1.value === c2.value) {
        return 0;
      }

      return -1;
    };

    metrics.counter200.sort(sortCounters);
    metrics.counter400.sort(sortCounters);
    metrics.counter500.sort(sortCounters);

    return metrics;
  }
}
